import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';

@Pipe({
    name: 'roleFilter',
    standalone: false
})

export class FacultyRoleFilterPipe implements PipeTransform {
    transform(item: any): any {
        if (!item) return '';
        let re = /\w+\d+\^Lead(?!\|)+/gi;
        if (item.match(re))
            return item;
    }
}

@Pipe({
    name: 'daysLeft',
    standalone: false
})

export class DaysLeftPipe implements PipeTransform {
    constructor(private utility: UtilityService) { }
    transform(item: string): number {
        if (!item) return 999;
        var today = this.utility.getCurrentDate();
        var futureDate = new Date(item);
        var days = Math.floor((Date.UTC(futureDate.getFullYear(), futureDate.getMonth(), futureDate.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / (1000 * 60 * 60 * 24));
        if (days < 0)
            days = 999;
        return days;
    }

}
